export default __webpack_public_path__ + "static/media/file-check-regular-icon.db438b57.svg";